module.exports = __webpack_public_path__ + "img/ZSCX.b6e3256d.png";